"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Error = void 0;

var tslib_1 = require("tslib");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var ui_vector_graphic_1 = require("@hopin-team/ui-vector-graphic");

var react_1 = tslib_1.__importDefault(require("react"));

var Error = function Error(_a) {
  var title = _a.title,
      props = tslib_1.__rest(_a, ["title"]);

  return react_1.default.createElement(ui_vector_graphic_1.VectorGraphic, tslib_1.__assign({}, props, {
    title: title !== null && title !== void 0 ? title : 'Error',
    viewBox: "0 0 320 250",
    __UIScope: "Error"
  }), react_1.default.createElement("rect", {
    width: "320",
    height: "198",
    fill: ui_symbols_1.COLOR.GREY[100],
    opacity: "0.75",
    rx: "12"
  }), react_1.default.createElement("g", {
    filter: "url(#Error__filter0_d)"
  }, react_1.default.createElement("rect", {
    width: "272",
    height: "198",
    x: "24",
    y: "24",
    fill: ui_symbols_1.COLOR.GREY.WHITE,
    rx: "8"
  }), react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.GREY[500],
    fillRule: "evenodd",
    d: "M52 177c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10a10 10 0 00-10-10zm1 13.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1zm-.47-3.5a.25.25 0 00.25-.22l.4-3.22a.5.5 0 00-.5-.56h-1.36a.5.5 0 00-.5.56l.4 3.22a.25.25 0 00.25.22h1.06z",
    clipRule: "evenodd"
  }), react_1.default.createElement("rect", {
    width: "72",
    height: "14",
    x: "72",
    y: "172",
    fill: ui_symbols_1.COLOR.GREY[200],
    rx: "7"
  }), react_1.default.createElement("rect", {
    width: "21",
    height: "14",
    x: "152",
    y: "172",
    fill: ui_symbols_1.COLOR.GREY[200],
    rx: "7"
  }), react_1.default.createElement("rect", {
    width: "212",
    height: "8",
    x: "72",
    y: "194",
    fill: ui_symbols_1.COLOR.GREY[100],
    rx: "4"
  }), react_1.default.createElement("rect", {
    width: "258",
    height: "122",
    x: "31",
    y: "31",
    fill: ui_symbols_1.COLOR.RED[100],
    rx: "5"
  }), react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.RED[300],
    fillRule: "evenodd",
    d: "M181.81 107.26l-20.184-34.52a1.521 1.521 0 00-1.301-.74h-.6a1.52 1.52 0 00-1.3.74L138.2 107.26a1.579 1.579 0 000 1.52l.28.46c.259.475.76.767 1.3.76h40.45a1.458 1.458 0 001.3-.76l.28-.46c.26-.473.26-1.047 0-1.52zM162.006 101a1 1 0 01-1.001 1h-2a1 1 0 01-1-1v-2a1 1 0 011-1h2a1 1 0 011.001 1v2zm-.941-7a.5.5 0 00.501-.44l.8-6.44a1.003 1.003 0 00-1-1.12h-2.721a.998.998 0 00-1 1.12l.8 6.44a.5.5 0 00.5.44h2.12z",
    clipRule: "evenodd"
  }), react_1.default.createElement("rect", {
    width: "258",
    height: "122",
    x: "31",
    y: "31",
    stroke: ui_symbols_1.COLOR.GREY.WHITE,
    strokeWidth: "2",
    rx: "5"
  })), react_1.default.createElement("defs", null, react_1.default.createElement("filter", {
    id: "Error__filter0_d",
    width: "296",
    height: "222",
    x: "16",
    y: "14",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, react_1.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), react_1.default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), react_1.default.createElement("feOffset", {
    dx: "4",
    dy: "2"
  }), react_1.default.createElement("feGaussianBlur", {
    stdDeviation: "6"
  }), react_1.default.createElement("feColorMatrix", {
    values: "0 0 0 0 0.886719 0 0 0 0 0.905528 0 0 0 0 0.945833 0 0 0 0.24 0"
  }), react_1.default.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), react_1.default.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }))));
};

exports.Error = Error;